import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  title: "ליווי סיעודי בבית",
  description: "מתן מענה מקצועי ומסור בבית המטופל, הכולל סיוע בפעולות היום-יום, השגחה רפואית ותמיכה רגשית המותאמת אישית לצרכי הקשיש ומשפחתו.",
  link: "/CaregiverServicePagesPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/home_nursing_care.png"
}, {
  title: "השגחה בבית חולים",
  description: "שירות ליווי והשגחה צמודה במהלך אשפוז, המבטיח שהיקרים לכם לעולם לא יישארו לבד. צוות המטפלים שלנו דואג לכל צורך רפואי או אישי מסביב לשעון.",
  link: "/NursingCareNowPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hospital_care_support.png"
}];
export default function RelatedServices() {
  return <section data-section-id="260433" id="שירותים-סיעודיים" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl font-default text-primary">
            שירותים סיעודיים משלימים
          </h2>
          <p className="max-w-[700px] text-muted-foreground md:text-lg font-default">
            גלו את מגוון פתרונות הטיפול והסיוע המקצועיים שלנו, שנועדו להעניק שקט נפשי ואיכות חיים למשפחתכם.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          {services.map((service, index) => <Card key={index} data-index={index} className="flex flex-col sm:flex-row overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 border-border bg-card rounded-lg">
              <div className="sm:w-2/5 h-56 sm:h-auto relative shrink-0 bg-muted">
                <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="flex flex-col flex-1">
                <CardHeader className="pb-4">
                  <CardTitle className="font-default text-2xl text-foreground">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-base mt-2 text-muted-foreground font-default">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardFooter className="mt-auto pt-0 pb-6">
                  <Button asChild variant="default" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-md">
                    <Link to={service.link}>
                      למידע נוסף
                      <ArrowRight className="mr-2 size-4 rotate-180" />
                    </Link>
                  </Button>
                </CardFooter>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}